export default __webpack_public_path__ + "static/media/2.93b13ddb.jpg";